"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdkConfigValidator = void 0;
var io_ts_1 = require("io-ts");
var utils_load_dynamic_script_1 = __importDefault(require("@getvim/utils-load-dynamic-script"));
exports.SdkConfigValidator = io_ts_1.type({
    sdkKey: io_ts_1.string,
    options: io_ts_1.intersection([
        io_ts_1.type({
            env: io_ts_1.union([
                io_ts_1.literal('local'),
                io_ts_1.literal('dev'),
                io_ts_1.literal('staging'),
                io_ts_1.literal('sandbox'),
                io_ts_1.literal('prod'),
            ])
        }),
        io_ts_1.partial({
            supportedWidgets: io_ts_1.array(io_ts_1.union([io_ts_1.literal('SCHEDULING'), io_ts_1.literal('SEARCH_AND_ACTION'), io_ts_1.literal('RESCHEDULE')]))
        }),
    ])
});
// https://js.getvim.com/web/v1.5/vim-sdk-docs.html#vim
var VimSdkClient = /** @class */ (function () {
    function VimSdkClient() {
    }
    VimSdkClient.prototype.init = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var Vim, _a, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(!(window === null || window === void 0 ? void 0 : window.Vim) || !this.client)) return [3 /*break*/, 7];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 6, , 7]);
                        if (!!(window === null || window === void 0 ? void 0 : window.Vim)) return [3 /*break*/, 3];
                        return [4 /*yield*/, utils_load_dynamic_script_1.default('vimSdk', 'https://js.getvim.com/web/v1.6/sdk.js')];
                    case 2:
                        _b.sent();
                        Vim = window.Vim;
                        if (typeof Vim === 'undefined') {
                            throw new Error('Could not initialize VIM SDK');
                        }
                        _b.label = 3;
                    case 3:
                        if (!!this.client) return [3 /*break*/, 5];
                        _a = this;
                        return [4 /*yield*/, window.Vim.apply(window, args)];
                    case 4:
                        _a.client = _b.sent();
                        _b.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        error_1 = _b.sent();
                        if (error_1) {
                            throw error_1;
                        }
                        throw new Error('Could not initialize VIM SDK');
                    case 7: return [2 /*return*/, true];
                }
            });
        });
    };
    VimSdkClient.prototype.showBookingDialog = function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return Promise.resolve()
            .then(function () {
            var _a;
            if (!_this.client) {
                throw new Error('SDK is not initialized');
            }
            return (_a = _this.client).showBookingDialog.apply(_a, args);
        })
            .catch(function (error) {
            if (error) {
                throw error;
            }
            throw new Error('Error occurred while booking');
        });
    };
    VimSdkClient.prototype.closeBookingDialog = function () {
        var _this = this;
        return Promise.resolve().then(function () {
            if (!_this.client) {
                throw new Error('SDK is not initialized');
            }
            return _this.client.closeDialog();
        });
    };
    VimSdkClient.prototype.getProviderAvailability = function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return Promise.resolve()
            .then(function () {
            var _a;
            if (!_this.client) {
                throw new Error('SDK is not initialized');
            }
            return (_a = _this.client).getProviderAvailability.apply(_a, args);
        })
            .catch(function (error) {
            if (error) {
                throw error;
            }
            throw new Error('Could not get provider availability');
        });
    };
    VimSdkClient.prototype.selectProvider = function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return Promise.resolve()
            .then(function () {
            var _a;
            if (!_this.client) {
                throw new Error('SDK is not initialized');
            }
            return (_a = _this.client).selectProvider.apply(_a, args);
        })
            .catch(function (error) {
            if (error) {
                throw error;
            }
            throw new Error('Could not get select provider');
        });
    };
    VimSdkClient.prototype.showRescheduleDialog = function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return Promise.resolve()
            .then(function () {
            var _a;
            if (!_this.client) {
                throw new Error('SDK is not initialized');
            }
            return (_a = _this.client).showRescheduleDialog.apply(_a, args);
        })
            .catch(function (error) {
            if (error) {
                throw error;
            }
            throw new Error('Error occurred while rescheduling');
        });
    };
    return VimSdkClient;
}());
exports.default = new VimSdkClient();
//# sourceMappingURL=vimSdkClient.js.map